import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { constants } from '../../../config/constants';
import { zynity_website } from '../../../config/external-routes';
import { loadAdminContent } from '../../../helpers/loadAdminContent';
import { Loading } from '../../ui/loading/Loading';
import { Accordion } from './accordion/Accordion';
import './body.scss';
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

export const Body = () => {
  const location = useLocation();
  const focusOrgId = new URLSearchParams(location.search).get('org'); // string | null
  const yii_url = zynity_website.yii_website_url;
  const user = useSelector(state => state.auth)
  const user_organizations = useSelector(state => state.user_organizations)

  const [userNewsContent, setUserNewsContent] = useState(false)

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await loadAdminContent(constants.admin_contents.user_news, user.access_token);
        if (alive) setUserNewsContent(res || '');
      } catch (e) {
        if (alive) setUserNewsContent('<em>No news available.</em>');
      }
    })();
    return () => { alive = false; };
  }, [user.access_token]);

  if (user_organizations.isLoading) {
    return <Loading centerPage={true} />
  }

  const organizations = user_organizations?.data?.data || user_organizations?.data || [];

  // Current month + year for the Member News card
  const currentDate = new Date();
  const monthYear = currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <>
      {/* Mobile-only quick links to jump to News / Plan */}
      <div className="d-lg-none text-end quick-links">
        <a href="#news-panel" className="qlink">News</a>
        <span className="sep">·</span>
        <a href="#plan-panel" className="qlink">Plan</a>
      </div>

      <div className="row mt-2 mt-sm-3 mt-lg-5">
        {/* CENTER on desktop, FIRST on mobile: Organizations */}
        <div className="col-12 col-lg-6 order-1 order-lg-2">
          <div className="row">
            <div className="col-12 p-0">
              {organizations.length === 0 && (
                <div className="alert alert-light" role="alert">
                  No organizations found for your account.
                </div>
              )}
              {organizations.map(org => (
                <Accordion
                  key={org.id}
                  org={org}
                  user={user}
                  headerColor={org?.color_key || org?.colorKey || org?.brand_key || org?.color}
                  initialOpen={String(org?.id) === String(focusOrgId)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* LEFT on desktop, SECOND on mobile: News */}
        <div className="col-12 col-lg-3 order-2 order-lg-1">
          {(userNewsContent || userNewsContent === '') && (
            <div id="news-panel" className="usernews mt-3 mt-lg-0">
              {/* Keep the card title as content (only column titles were removed) */}
              <h5>Member News</h5>
              <p style={{ marginTop: '-10px', marginBottom: '20px', fontStyle: 'italic', fontWeight: 'bold' }}>
                {monthYear}
              </p>
              <div dangerouslySetInnerHTML={{ __html: userNewsContent }}></div>
            </div>
          )}
        </div>

        {/* RIGHT on desktop, THIRD on mobile: Development */}
        <div className="col-12 col-lg-3 order-3 order-lg-3">
          <div id="plan-panel" className="mydev-card mt-3 mt-lg-0">
            <a href={`${yii_url}/mystory/index`} >
              <button className="theme-btn btn-style-one dev-btn w-100 mb-2">My Story</button>
            </a>
            <a href={`${yii_url}/Development/index`} >
              <button className="theme-btn btn-style-one dev-btn w-100 mb-2">My Development</button>
            </a>
            <Link to="/how-lead">
              <button className="theme-btn btn-style-one dev-btn w-100">How You Lead</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
